import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { reducerProvider, reducerToken } from './reducers';
import { SHOP_FEATURE } from './shop-state';

@NgModule({
  imports: [StoreModule.forFeature(SHOP_FEATURE, reducerToken)],
  providers: [reducerProvider],
})
export class ShopStoreModule {}
